module.exports = __webpack_public_path__ + "static/media/fj.929fb1ac.svg";